module.exports = __webpack_public_path__ + "static/media/mileage_2_8.11abf3ec.png";